const DEFAULT_OPTIONS = {
    showClear: true,
    showClose: true,
    allowInputToggle: true,
    useCurrent: false,
    ignoreReadonly: true,
    viewMode: 'years',
    locale: 'nl',
    maxDate: null,
    icons: {
        time: 'fa fa-clock-o',
        date: 'fa fa-calendar',
        up: 'fa fa-angle-up',
        down: 'fa fa-angle-down',
        previous: 'fa fa-angle-left',
        next: 'fa fa-angle-right',
        today: 'fa fa-dot-circle-o',
        clear: 'fa fa-trash',
        close: 'fa fa-times',
    },
    format:'DD-MM-YYYY',
};

class DatePicker {

    constructor() {
        document.querySelectorAll('.date input').forEach(picker => {
            let options = Object.assign({}, DEFAULT_OPTIONS);

            if (picker.getAttribute('data-format')) {
                options.format = picker.getAttribute('data-format');
            }
            if (picker.getAttribute('data-default')) {
                options.viewDate = picker.getAttribute('data-default');
            }
            if (picker.getAttribute('data-min')) {
                options.minDate = picker.getAttribute('data-min');
            }
            if (picker.getAttribute('data-max')) {
                options.maxDate = picker.getAttribute('data-max');
            }

            $(picker).datetimepicker(options);
        })
    }

}
